import React from "react";
import { Link } from "react-router-dom";

const CartEmpty: React.FC = () => (
  <div className="text-center py-8">
    {/*  */}
    <section className="relative w-full mt-[-39%] z-30 mb-[20px]">
      <div className="md:relative gap-10 z-50 flex flex-col items-center justify-center w-full">
        <div className="relative w-[72%] text-[#005D6E] mt-[20px] mb-[25px]"></div>
        <div className="bg-white rounded-xl border border-gray-300 relative sm:w-[72%] opacity-80 px-10 py-20 text-[#005D6E]">
          <div >
            <div>
              <p
                className=" text-[rgb(0,34,56)]
       block  text-[25px] font-medium text-center
     h-[38px] leading-[38.4px] mb-1 ">
                Your Cart is empty!
              </p>

              <Link to={"/flavours"}>
                <button
                  className="mt-[20px] w-[200px] h-[60px] text-[16px] text-white font-bold rounded-full bg-[#75A7AD] 
items-center justify-center 
      focus:outline-none">
                  Continue Browsing
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default CartEmpty;
